module.exports = __webpack_public_path__ + "static/media/user_interviews.bd26e830.png";